import { isTrackvisionDeviceType } from './device'
import { Helper } from '@/mixin/helper'
import store from '@/state/store'

const CAPTURE_EVENT_CATEGORY_IDS = [1, 2]
const BSD_CATEGORY_IDS = [8]
export const UPLOADING_PROCCESS = ['loading', 'checking']
export const CONNECTING_PROCESS = ['requesting']

export function isDmsAdas(alert) {
  const alertCategories = alert.alert?.alertCategories || alert.alertCategories || []
  return alertCategories.some(({ alertCategoryId }) =>
    Helper.methods.isDmsAdas.call(Helper.methods, alertCategoryId)
  )
}

export function isCaptureEvent(alert) {
  if (!store.getters['identity/hasAccess']('b3e-capture-picture-event:read')) return false
  const alertCategories = alert.alert?.alertCategories || alert.alertCategories || []
  return alertCategories.some(({ alertCategoryId }) =>
    CAPTURE_EVENT_CATEGORY_IDS.includes(alertCategoryId)
  )
}

export function isBsdAlert(alert) {
  if (!store.getters['identity/hasAccess']('e1r-bsd-blind-spot-detection:read')) return false
  const alertCategories = alert.alert?.alertCategories || alert.alertCategories || []
  return alertCategories.some(({ alertCategoryId }) => BSD_CATEGORY_IDS.includes(alertCategoryId))
}

export function canShowAlertMediaPanel(alert, { getDeviceType }) {
  const isEligibleMediaAlert =
    isDmsAdas(alert) || hasCaptureEventMedia(alert, { getDeviceType }) || isBsdAlert(alert)
  return isEligibleMediaAlert && hasMediaPanelState(alert)
}

export function hasMediaPanelState(alert) {
  return (
    isMediaPanelLoading(alert) ||
    isMediaPanelFailed(alert) ||
    alert.canCheck ||
    alert.canRequest ||
    hasMediaPanelContent(alert)
  )
}

export function isMediaPanelFailed(alert) {
  return alert.pollingStatus === 'failed'
}

export function isMediaPanelLoading(alert) {
  const isOfflineDevice = alert.isOfflineDevice
  const isConnecting = CONNECTING_PROCESS.includes(alert.pollingStatus)
  const isUploading = UPLOADING_PROCCESS.includes(alert.pollingStatus)
  return (isUploading || isConnecting) && !isOfflineDevice
}

export function hasMediaPanelContent(alert) {
  return !!alert.videoData
}

export function hasCaptureEventMedia(alert, { getDeviceType }) {
  if (!isCaptureEvent(alert)) return false
  const isParentCam =
    alert.vehicle?.sensor?.some((sensor) => sensor.sensorCode === 35) &&
    isTrackvisionDeviceType(getDeviceType(alert.vehicle.device?.deviceCode))

  const isChildCam = !!alert.vehicle?.children?.length || !!alert.childVehicleId

  const hasExistingMedia = alert.media?.length > 0 || hasMediaPanelContent(alert)

  return isParentCam || isChildCam || hasExistingMedia
}

export function getAlertMediaRequestType(alert) {
  if (isCaptureEvent(alert)) return 'capture-event'

  const categories = alert.alert?.alertCategories ?? []
  const hasCategory = (checker) =>
    categories.some(({ alertCategoryId }) => checker.call(Helper.methods, alertCategoryId))

  if (hasCategory(Helper.methods.isDms)) return 'dms'
  if (hasCategory(Helper.methods.isAdas)) return 'adas'
  if (hasCategory(Helper.methods.isBsd)) return 'bsd'

  return null
}
